import { useFlagshipFlag } from '../../helpers/useFlagshipFlag';
import { CHECKOUT_PAGE_TITLE_TEXT } from '../experiments.constants';

export const useCheckoutPageTitleText = (visitorExposed: boolean) =>
  useFlagshipFlag({
    key: CHECKOUT_PAGE_TITLE_TEXT,
    defaultValue: 'Confirm Your Insurance Application',
    visitorExposed: visitorExposed,
  });
